import classNames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useHistory } from 'react-router';

import { TextButton } from '@xingternal/button';
import { IconArrowLeft, IconArrowRight } from '@xingternal/icons';

import { redirectUrl } from '@/helpers/redirect-url';
import { useLoginStates } from '@/hooks';

import { navigationPointer } from '../../../../posting-header.proptypes';

import styles from './navigation-button.css';

export const LEFT = 'left';
export const RIGHT = 'right';

const NavigationButton = ({ href, text, translation, side, fencedInSoftLogin = true, isAnchor }) => {
  const { isSoftLoggedIn } = useLoginStates();
  const history = useHistory();

  const isRightSide = side === RIGHT;
  const icon = isRightSide ? IconArrowRight : IconArrowLeft;

  const seoFriendlyHref = href.split('?')[0];
  const isAnchorLink = (fencedInSoftLogin && isSoftLoggedIn) || isAnchor;
  const isRouterLink = !isAnchorLink;
  const handleNavigate = (e) => redirectUrl(e, href, isRouterLink ? history : null);

  return (
    <TextButton
      iconAfter={isRightSide}
      icon={icon}
      onClick={handleNavigate}
      className={classNames(styles.navigationButton, { [styles['navigationButton--right']]: isRightSide })}
      data-testid={`${side}NavigationButton`}
      href={seoFriendlyHref}
    >
      {text || <FormattedMessage id={`${translation.id}`} values={translation.values} />}
    </TextButton>
  );
};

const navigationPropTypes = {
  ...navigationPointer,
  side: PropTypes.oneOf([LEFT, RIGHT]),
  fencedInSoftLogin: PropTypes.bool,
  isAnchor: PropTypes.bool,
};

NavigationButton.propTypes = navigationPropTypes;

export default NavigationButton;
